module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodsnow-90987a2dd00a7cae1119d93519fdd8cd.png";